module.exports = __webpack_public_path__ + "empty-b702de8fecc1823b1fb2.svg";